/* Hauser MX — visor de fotos de la propiedad (Fase 8).
 *
 * En una inmobiliaria las fotos SON el producto: es la parte de la ficha donde
 * más tiempo pasa el visitante. Sustituye al bloque nativo de Horizon, que
 * funcionaba pero cambiaba de foto de golpe, sin gesto y sin narrativa.
 *
 * Cuatro cosas, en orden de importancia real:
 *   1. Transición líquida por shader entre fotos (motor de hauser-gl.js).
 *   2. Arrastre con inercia: se lanza y encaja en la siguiente.
 *   3. Modo "recorrido": las reproduce solas y se detiene al primer control
 *      que toques — nunca pelea contra el visitante.
 *   4. Pantalla completa con zoom, sobre un <dialog> nativo.
 *
 * Sin JS o en nivel `flat`, el CSS deja las fotos apiladas en una columna:
 * se ve la galería COMPLETA, solo que sin coreografía. Nunca una pantalla en
 * blanco esperando a un script.
 */
(function () {
  'use strict';

  var H = window.Hauser;
  if (!H) return;

  var raiz = document.querySelector('[data-hauser-galeria]');
  if (!raiz) return;

  var escenario = raiz.querySelector('[data-hauser-galeria-escenario]');
  var capas = Array.prototype.slice.call(raiz.querySelectorAll('[data-hauser-galeria-capa]'));
  var minis = Array.prototype.slice.call(raiz.querySelectorAll('[data-hauser-galeria-mini]'));
  var etiquetaActual = raiz.querySelector('[data-hauser-galeria-actual]');
  var btnPrev = raiz.querySelector('[data-hauser-galeria-prev]');
  var btnNext = raiz.querySelector('[data-hauser-galeria-next]');
  var btnRecorrido = raiz.querySelector('[data-hauser-galeria-recorrido]');
  var btnExpandir = raiz.querySelector('[data-hauser-galeria-expandir]');
  var lightbox = document.querySelector('[data-hauser-galeria-lightbox]');
  var total = capas.length;

  var indice = 0;
  var escena = null;
  var recorriendo = false;
  var temporizador = null;

  /* ── Estado visible ───────────────────────────────────────────────── */

  function pintar(i) {
    indice = ((i % total) + total) % total;

    capas.forEach(function (c, k) {
      c.classList.toggle('is-activa', k === indice);
      /* Un vídeo fuera de vista tiene que dejar de sonar. */
      if (k !== indice) {
        var v = c.querySelector('video');
        if (v && !v.paused) v.pause();
      }
    });

    minis.forEach(function (m, k) {
      var on = k === indice;
      m.classList.toggle('is-activa', on);
      m.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && m.scrollIntoView) {
        m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    });

    if (etiquetaActual) etiquetaActual.textContent = String(indice + 1);
  }

  function ir(i, porGesto) {
    var destino = ((i % total) + total) % total;
    if (destino === indice) return;

    /* Cualquier control detiene el recorrido automático. Que la página siga
       avanzando sola después de que el visitante tomó el mando es de las cosas
       que más molestan de un slideshow. */
    if (porGesto && recorriendo) detenerRecorrido();

    if (escena && capas[destino].dataset.tipo === 'image' && capas[indice].dataset.tipo === 'image') {
      escena.ir(destino);
    }
    pintar(destino);
  }

  /* ── Shader ───────────────────────────────────────────────────────── */

  /* Solo las fotos entran al shader. Un vídeo no es una textura estática, así
     que sus diapositivas se muestran con el elemento nativo y el canvas se
     esconde mientras tanto (lo hace el CSS con `data-tipo`). */
  function fuentes() {
    var lista = [];
    capas.forEach(function (c) {
      var img = c.querySelector('img');
      if (!img) { lista.push(null); return; }
      var srcset = img.getAttribute('srcset');
      var objetivo = escenario.getBoundingClientRect().width * H.dpr;
      if (!srcset) { lista.push(img.currentSrc || img.src); return; }
      var cand = srcset.split(',')
        .map(function (p) { var t = p.trim().split(/\s+/); return { url: t[0], w: parseInt(t[1], 10) || 0 }; })
        .filter(function (c2) { return c2.url && c2.w; })
        .sort(function (a, b) { return a.w - b.w; });
      if (!cand.length) { lista.push(img.currentSrc || img.src); return; }
      for (var i = 0; i < cand.length; i++) if (cand[i].w >= objetivo) { lista.push(cand[i].url); return; }
      lista.push(cand[cand.length - 1].url);
    });
    return lista;
  }

  function montarShader() {
    if (H.tier === 'flat' || !window.HauserGL || !window.HauserGL.disponible()) return;
    var srcs = fuentes();
    /* Con algún hueco (un vídeo entre las fotos) el shader no puede encadenar
       toda la galería: se monta igual, y `ir()` solo lo usa cuando origen y
       destino son ambos fotos. */
    if (!srcs.filter(Boolean).length) return;

    escena = new window.HauserGL.Escena(escenario, {
      fuentes: srcs.map(function (s) { return s || srcs.filter(Boolean)[0]; }),
      parallax: 0.022,
      intensidad: 0.9,
      grano: 0.016,
      /* IMPRESCINDIBLE: una propiedad tiene 18-24 fotos. Subirlas todas a la
         GPU son ~40 MB de memoria de vídeo y en un teléfono de gama media el
         navegador tira el contexto sin avisar. */
      perezoso: true
    });

    if (!H.mqCoarse.matches) {
      escenario.addEventListener('pointerenter', function () { escena.hover(true); });
      escenario.addEventListener('pointerleave', function () { escena.hover(false); });
    }
  }

  /* ── Modo recorrido ───────────────────────────────────────────────── */

  function pintarBotonRecorrido() {
    if (!btnRecorrido) return;
    var play = btnRecorrido.querySelector('[data-icono-play]');
    var pausa = btnRecorrido.querySelector('[data-icono-pausa]');
    var texto = btnRecorrido.querySelector('[data-hauser-galeria-recorrido-texto]');
    if (play) play.hidden = recorriendo;
    if (pausa) pausa.hidden = !recorriendo;
    if (texto) texto.textContent = recorriendo ? 'Detener' : 'Ver recorrido';
    btnRecorrido.setAttribute('aria-pressed', recorriendo ? 'true' : 'false');
  }

  function arrancarRecorrido() {
    if (recorriendo || total < 2) return;
    recorriendo = true;
    pintarBotonRecorrido();
    temporizador = setInterval(function () {
      /* Si la pestaña no está visible, no se avanza: el visitante volvería y
         se habría perdido medio recorrido. */
      if (document.hidden) return;
      ir(indice + 1, false);
    }, 3200);
  }

  function detenerRecorrido() {
    recorriendo = false;
    if (temporizador) clearInterval(temporizador);
    temporizador = null;
    pintarBotonRecorrido();
  }

  if (btnRecorrido) {
    btnRecorrido.addEventListener('click', function () {
      recorriendo ? detenerRecorrido() : arrancarRecorrido();
    });
  }

  /* ── Controles ────────────────────────────────────────────────────── */

  if (btnPrev) btnPrev.addEventListener('click', function () { ir(indice - 1, true); });
  if (btnNext) btnNext.addEventListener('click', function () { ir(indice + 1, true); });
  minis.forEach(function (m, k) {
    m.addEventListener('click', function () { ir(k, true); });
  });

  /* Teclado. Solo cuando el foco está dentro de la galería, para no secuestrar
     las flechas del resto de la página. */
  raiz.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); ir(indice - 1, true); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); ir(indice + 1, true); }
    else if (e.key === 'Home') { e.preventDefault(); ir(0, true); }
    else if (e.key === 'End') { e.preventDefault(); ir(total - 1, true); }
  });

  /* ── Arrastre ─────────────────────────────────────────────────────── */

  /* Se implementa a mano con eventos de puntero y no con Draggable porque
     aquí NO se arrastra un elemento: se arrastra para CAMBIAR DE FOTO. Lo que
     importa es la dirección y la velocidad del gesto, no la posición final. */
  function montarArrastre() {
    if (H.tier === 'flat' || total < 2) return;

    var x0 = 0, t0 = 0, arrastrando = false;

    escenario.addEventListener('pointerdown', function (e) {
      /* Los controles no arrastran: son botones. */
      if (e.target.closest('button, a, video, iframe')) return;
      arrastrando = true;
      x0 = e.clientX;
      t0 = Date.now();
      escenario.classList.add('is-arrastrando');
    });

    escenario.addEventListener('pointerup', function (e) {
      if (!arrastrando) return;
      arrastrando = false;
      escenario.classList.remove('is-arrastrando');

      var dx = e.clientX - x0;
      var dt = Date.now() - t0;
      var velocidad = Math.abs(dx) / Math.max(dt, 1);

      /* Dos formas de pasar de foto: recorrer un cuarto del ancho, o hacer un
         gesto corto pero rápido (más de 0.45 px/ms). Sin lo segundo, un
         "flick" del pulgar no hace nada y se siente roto. */
      var umbral = escenario.getBoundingClientRect().width * 0.22;
      if (Math.abs(dx) > umbral || (velocidad > 0.45 && Math.abs(dx) > 24)) {
        ir(indice + (dx < 0 ? 1 : -1), true);
      }
    });

    escenario.addEventListener('pointercancel', function () {
      arrastrando = false;
      escenario.classList.remove('is-arrastrando');
    });
  }

  /* ── Pantalla completa ────────────────────────────────────────────── */

  function montarLightbox() {
    if (!lightbox || !btnExpandir) return;
    var cerrar = lightbox.querySelector('[data-hauser-galeria-cerrar]');
    var lista = lightbox.querySelector('[data-hauser-galeria-lightbox-lista]');

    btnExpandir.addEventListener('click', function () {
      detenerRecorrido();
      /* `showModal` da modal, foco atrapado y Escape sin escribir una línea. */
      if (lightbox.showModal) lightbox.showModal();
      else lightbox.setAttribute('open', '');
      document.documentElement.setAttribute('scroll-lock', '');

      /* Se abre por la foto que estabas viendo, no por la primera. */
      var destino = lista && lista.querySelector('[data-hauser-galeria-lb="' + indice + '"]');
      if (destino) destino.scrollIntoView({ block: 'start' });
    });

    var cerrarTodo = function () {
      if (lightbox.close) lightbox.close();
      else lightbox.removeAttribute('open');
      document.documentElement.removeAttribute('scroll-lock');
    };

    if (cerrar) cerrar.addEventListener('click', cerrarTodo);
    lightbox.addEventListener('close', function () {
      document.documentElement.removeAttribute('scroll-lock');
    });
    /* Clic en el fondo (fuera de las fotos) cierra. */
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lista) cerrarTodo();
    });
  }

  /* ── Arranque ─────────────────────────────────────────────────────── */

  H.listo(function () {
    raiz.setAttribute('data-hauser-galeria-listo', '');
    pintar(0);
    montarShader();
    montarArrastre();
    montarLightbox();
    pintarBotonRecorrido();
  });
})();
